import { Alert, Button, Stack, useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { useBoolean } from 'usehooks-ts';
import { AccountPlanType, RoutePath } from 'enums';
import { useAuth } from 'hooks';
import { daysUntilPlanEnds, planIsOnGoing } from 'utils';

const UpgradeAccountBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { value: isBannerOpen, setFalse: closeBanner } = useBoolean(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const isFreeAccount = !user?.organization?.accountPlan || user.organization.accountPlan.type === AccountPlanType.Basic;
  const isDashboardPage = location.pathname.startsWith('/dashboard');

  if (!isDashboardPage) {
    return null;
  }

  if (isFreeAccount) {
    if (!isBannerOpen) {
        return null;
    }

    return (
      <Alert
        onClose={() => closeBanner()}
        severity='info'
        sx={{
          borderRadius: 0,
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          py: isMobile ? 1 : 2,
            '& .MuiAlert-icon':{
                alignItems:'center',
            }
        }}
      >
        <Stack
          direction={isMobile ? "column" : "row"}
          alignItems={isMobile ? "stretch" : "center"}
          gap={isMobile ? 1 : 2}
        >
          <span>Unlock premium features!</span>
          <Stack
            direction={isMobile ? "row" : "row"}
            gap={1}
            justifyContent={isMobile ? "space-between" : "flex-start"}
          >
            <Button
              variant="contained"
              color="primary"
              component={RouterLink}
              to={`/${RoutePath.ManageAccount}`}
              size="small"
              fullWidth={isMobile}
            >
              Upgrade
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => navigate(`/${RoutePath.Dashboard}/${RoutePath.ApplyCoupon}`)}
              size="small"
              fullWidth={isMobile}
            >
              Coupon
            </Button>
          </Stack>
        </Stack>
      </Alert>
    );
  }

  if (!user?.organization?.accountPlan?.endDate) {
    return null;
  }

  if (planIsOnGoing(user?.organization?.accountPlan?.endDate) || !isBannerOpen) {
    return null;
  }

  const daysLeft = user?.organization?.accountPlan?.endDate
    ? daysUntilPlanEnds(new Date(user?.organization?.accountPlan?.endDate))
    : null;

  return (
    <Alert
      onClose={() => closeBanner()}
      severity='warning'
      sx={{
        borderRadius: 0,
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        py: isMobile ? 1 : 2,
          '& .MuiAlert-icon':{
              alignItems:'center',
          }
         }}
    >
      <Stack
        direction={isMobile ? "column" : "row"}
        alignItems={isMobile ? "stretch" : "center"}
        gap={isMobile ? 1 : 2}
      >
        <span>Plan expires in <strong>{daysLeft}</strong> days</span>
        <Button
          variant="contained"
          color="warning"
          component={RouterLink}
          to={`/${RoutePath.ManageAccount}`}
          size="small"
          fullWidth={isMobile}
        >
          Upgrade
        </Button>
      </Stack>
    </Alert>
  );
};

export default UpgradeAccountBanner;
